import { WalletSetupStep } from "@/constants/enums";

let navigationLocked = false;

export function isWalletSetupLockedStep(step: WalletSetupStep): boolean {
  return step === WalletSetupStep.Loading || step === WalletSetupStep.Save;
}

export function setWalletSetupNavigationLocked(locked: boolean) {
  navigationLocked = locked;
}

export function isWalletSetupNavigationLocked(): boolean {
  return navigationLocked;
}

export function resetWalletSetupLock() {
  navigationLocked = false;
}
